module.exports = __webpack_public_path__ + "static/img-forgot-password-011fc11eac80609c05f3481feaee1449.svg";